import { render } from "./PostCloseConnectV2.vue?vue&type=template&id=5b3351ed&scoped=true"
import script from "./PostCloseConnectV2.vue?vue&type=script&lang=js"
export * from "./PostCloseConnectV2.vue?vue&type=script&lang=js"

import "./PostCloseConnectV2.vue?vue&type=style&index=0&id=5b3351ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3351ed"]])

export default __exports__